import { render, staticRenderFns } from "./ProductInfoList.vue?vue&type=template&id=200fd707&scoped=true"
import script from "./ProductInfoList.vue?vue&type=script&lang=js"
export * from "./ProductInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200fd707",
  null
  
)

export default component.exports